<template>
  <button
    class="vz-button"
    :class="[
      `vz-button--${type}`,
      {
        'vz-button--disabled': disabled,
        'vz-button--block': block,
        'vz-button--round': round,
      },
    ]"
    :disabled="disabled"
    @click="handleClick"
  >
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: 'VzButton',
  props: {
    type: {
      type: String,
      default: 'info',
      validator: value => ['info', 'primary', 'pink'].includes(value),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    block: {
      type: Boolean,
      default: true,
    },
    round: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleClick(event) {
      if (this.disabled) return
      this.$emit('click', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.vz-button {
  display: inline-block;
  padding: 6px 12px;
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  border: none;
  outline: none;
  cursor: pointer;
  transition: opacity 0.3s;
  margin: 5px 0;
  white-space: nowrap;

  &--block {
    display: block;
    width: 100%;
  }

  &--round {
    border-radius: 50%;
  }

  &--info {
    background-color: #f0f7fe;
    color: #006cff;
  }

  &--primary {
    background: linear-gradient(90deg, #006cff 0%, #00a5ff 100%);
    color: #fff;
  }

  &--pink {
    background: linear-gradient(180deg, #f44 0%, #ff7979 100%);
    color: #fff;
  }

  &--disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  & + .vz-button {
    margin-left: 10px;
  }
}

// 当按钮是块级元素时，确保间距正确
.vz-button--block + .vz-button--block {
  margin-left: 0;
  margin-top: 10px;
}
</style>
